export default `
    <form class="#: data.classes || "" # #=data.bsc||""#" id="#= data.id #" method="post" action="#= data.action #">
        #= data.components #
    </form>
`;
